export default String.raw`
{% assign product = include -%}

{% assign isInComparison = false -%}
{% for itemId in customer.ComparisonToolItems -%}
    {% if itemId == product.Id -%}
        {% assign isInComparison = true -%}
    {% endif -%}
{% endfor -%}

{% assign noProductOnControlledStock = false -%}
{% if product.StockLevel.QuantityControl == true and product.StockLevel.Value == 0 -%}
    {% assign noProductOnControlledStock = true -%}
{% endif -%}
{% assign productWithAttributes = false -%}
{% assign notifyAvailability = false -%}
{% if product.Availability.Status == 3 or noProductOnControlledStock -%}
    {% assign notifyAvailability = true -%}
{% endif -%}
{% assign isPhantom = false -%}
{% if product.AttributesList.Clip == true -%}
    {% assign isPhantom = true -%}
{% endif -%}
{% assign attributesPolyvalentSize = product.AttributesList.AttributesPolyvalent | Size -%}
{% assign attributesEditableSize = product.AttributesList.AttributesEditable | Size -%}
{% if attributesPolyvalentSize > 0 or attributesEditableSize > 0 -%}
    {% assign productWithAttributes = true -%}
{% endif -%}

{% if settings.grapicalVariantsPresentation != 'Variants_No' -%}
    {% if product.AttributesList.Clip == true -%}
        {% assign isGraphicalPresentation = true -%}
        {% if settings.grapicalVariantsPresentation == 'Variants_Thumbnails' -%}
            {% assign graphicalVariantsClass = 'withGraphicalVariants' -%}
        {% else -%}
            {% assign graphicalVariantsClass = 'withColorVariants' -%}
        {% endif -%}
    {% elsif product.HasAttributes == true -%}
        {% if settings.grapicalVariantsPresentation == 'Variants_Colors' -%}
            {% assign graphicalVariantsClass = 'withColorVariants' -%}
            {% assign isGraphicalPresentation = true -%}
        {% else -%}
            {% assign graphicalVariantsClass = '' -%}
            {% assign isGraphicalPresentation = false -%}
        {% endif -%}
    {% else -%}
        {% assign graphicalVariantsClass = '' -%}
        {% assign isGraphicalPresentation = false -%}
    {% endif -%}
{% else -%}
    {% assign graphicalVariantsClass = '' -%}
    {% assign isGraphicalPresentation = false -%}
{% endif -%}

{% assign showCouponsOnProductsLists = false -%}
{% assign showCouponsPopup = false -%}
{% if settings.couponsPresentation == "yes" and settings.showCouponsOnProductsLists == "yes" -%}
    {% assign showCouponsOnProductsLists = true -%}
{% endif -%}
{% if product.HasCoupons and showCouponsOnProductsLists -%}
    {% assign showCouponsPopup = true -%}
{% endif -%}

{% assign productImageForCoupons = "" -%}
{% if product.Image.Id > 0 and product.Image.Link != null -%}
    {% capture productImageForCoupons %}img/small/{{ product.Image.Id }}/{{ product.Image.Link }}{% endcapture -%}
{% elsif product.Image.ExternalUrl != null -%}
    {% capture productImageForCoupons %}{{ product.Image.ExternalUrl }}{% endcapture -%}
{% endif -%}

{% if view == 'list' -%}
    <div class="products-list__list-view-product product-phantom-js product-item-js">
        <a tabindex="-1" href="{{ page.BaseHref }}{{ product.Url }}" class="products-list__list-view-product--product-container-link" aria-label="{{translations.ShowDetails}}" ></a>
        <div class="image-container">
            <div class="image-container__wrapper">
                {% if product.ImageId == -1 -%}
                    <svg class="no-image">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#image-{{settings.iconStyle}}"></use>
                    </svg>
                {% else -%}
                    {{ product | Img:'large' }}
                {% endif -%}
                <div class='image-container__flags'>
                    {% if product.Archival -%}
                        <div class="ribbon archival">{{ translations.ArchivalProduct}}</div>
                    {% endif -%}
                    {% for flag in product.Flags limit:2 -%}
                        <div class="ribbon {{flag.Type}}">
                            {% if flag.Type == "Reward" -%}
                                {{ translations.PointsProduct }}
                            {% else -%}
                                {{ flag.Text }}
                            {% endif -%}
                        </div>
                    {% endfor %}
                </div>
                {% if settings.showRotateImageOnList == 'showRotateImageOnList-yes' -%}
                    {% assign is360photo = false -%}
                    {% for attribute in product.AttributesList.Attributes -%}
                        {% assign attributeName = attribute.Name | Downcase -%}
                        {% if attributeName contains '360photo' -%}
                            {% if attribute.Values[0].Value != '' -%}
                                {% assign is360photo = true -%}
                                <input type="hidden" class="photoLink" value="{{attribute.Values[0].Value}}">
                            {% endif -%}
                        {% endif -%}
                    {% endfor -%}

                    {% if is360photo == true -%}
                        <div class="open360 open360-js open-popup-with-form" data-popup-class=".image-rotate-popup" data-product-list="true">
                            <svg>
                                <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#360'></use>
                            </svg>
                        </div>
                    {% endif -%}
                {% endif -%}
                <div class="product-item__phantom product-item__new {% if isGraphicalPresentation == false -%} hidden {% endif -%}" data-url="{{ page.BaseHref }}{{ product.Url }}" data-base="{{ page.BaseHref }}" data-id="{{ product.Id }}" data-attributes="{{ product.HasAttributes }}" data-poly="{{ product.AttributesPolyvalent.length }}" data-clip="{{product.AttributesList.Clip}}" data-settings="{{ settings.grapicalVariantsPresentation }}">
                        {% if settings.grapicalVariantsPresentation == 'Variants_DropDownList' -%}
                        <div class="form__input-info input-info-js on-label" data-attribute-name ></div>
                        <div class="select__input product-item__phantom--select select-js">
                            <span class="selected-js product-item__phantom--select-active"></span>
                            <svg>
                                <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}'></use>
                            </svg>
                            <ul class="product-item__phantom-first product-item__phantom-row options-js" data-id="{{ product.Id }}" ></ul>
                        </div>
                    {% else -%}
                    <div class="product-item__phantom-first product-item__phantom-row" data-id="{{ product.Id }}" data-attributes="{{ product.HasAttributes }}" ></div>
                {% endif -%}
                </div>
            </div>
        </div>
        <div class="content-and-quantity-container">
            <div class="content-container">
                <div class="content-container__name">
                    <a href="{{ page.BaseHref }}{{ product.Url }}">{{ product.NameNoHtml | H }}</a>
                </div>
                <input type="checkbox" id="see-more-{{product.Id}}" class="see-more-checkbox" aria-label="{{ translations.SeeMore }}">
                <div class="content-container__attributes">
                    {% comment -%}<!-- Product Code -->{% endcomment -%}
                    <div class="attribute">
                        <span class="attribute__name">{{ translations.ProductCode }}:</span>
                        <span class="attribute__value">{{ product.Code | H }}</span>
                        <svg aria-label="{{ translations.AfterCopyMessage }}" tabindex="0" role="button" width="20" height="20" class="copy-js" data-text="{{ product.Code | H }}">
                            <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#copy-{{settings.iconStyle}}'></use>
                        </svg>
                    </div>

                    {% if settings.showShortDesc == 'yes' -%}
                        {% comment -%}<!-- Short description -->{% endcomment -%}
                        {% if product.ShortDescription != '' -%}
                            <div class="description">{{ product.ShortDescription }}</div>
                        {% endif -%}
                    {% else -%}
                        {% assign attributesSize = product.AttributesList.Attributes | Size -%}
                        {% if settings.showAttributesOnProductsPage == 'yes' and attributesSize > 0 -%}
                            {% comment -%}<!-- Attributes specific to product without 360 photo -->{% endcomment -%}
                            
                            {% unless settings.showAllAttributesOnListView -%}
                                {% comment -%}<!-- Settings: limit to n attributes -->{% endcomment -%}
                                {% assign attributesSize = settings.attributesQuantityOnListView | ToInt -%}
                            {% endunless -%}
                    
                            {% for attribute in product.AttributesList.Attributes limit: attributesSize -%}
                                {% assign attributeName = attribute.Name | Downcase -%}
                    
                                {% if attributeName contains '360photo' -%}
                                    {% comment -%} <!-- Do nothing ... -->{% endcomment -%}
                                {% else -%}
                                    <div class="attribute">
                                        <span class="attribute__name">{{ attribute.Name }}:</span>
                                        <span class="attribute__value">
                                            {% for value in attribute.Values %}
                                                {{ value.Value }}{% if forloop.index != forloop.length %}, {% endif %}
                                            {% endfor %}
                                        </span>
                                    </div>
                                {% endif -%}
                            {% endfor %}
                        {% endif -%}
                    
                        {% comment -%}<!-- Manufacturer -->{% endcomment -%}
                        {% if product.Manufacturer.Name -%}
                            <div class="attribute">
                                <span class="attribute__name">{{ translations.Manufacturer }}:</span>
                                <span class="attribute__value">{{ product.Manufacturer.Name }}</span>
                            </div>
                        {% endif -%}
                        
                        {% comment -%}<!-- Brand -->{% endcomment -%}
                        {% if product.Brand.Name -%}
                            <div class="attribute">
                                <span class="attribute__name">{{ translations.Brand }}:</span>
                                <span class="attribute__value">{{ product.Brand.Name }}</span>
                            </div>
                        {% endif -%}
                    
                        {% comment -%}<!-- Weight in kg -->{% endcomment -%}
                        {% if product.Weight > 0 -%}
                            <div class="attribute">
                                <span class="attribute__name">{{ translations.Weight }}:</span>
                                <span class="attribute__value">{{ product.Weight | Normalize }} {{ translations.Kg }}</span>
                            </div>
                        {% endif -%}
                    {% endif -%}
                </div>
                <label for="see-more-{{product.Id}}" class="see-more__button hidden-js">
                    {{ translations.See }}
                    <span class="more">{{ translations.More | Downcase }}</span>
                    <span class="less">{{ translations.Less | Downcase }}</span>
                    <svg class="see-more__icon">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
                    </svg>
                </label>
            </div>
            <div class="quantity-container">
                {% if customer.HidePrices and usr.Authenticated == false -%}
                    <div class="quantity-container__login-to-see-prices">
                        <svg class="icon">
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#lock-alt-{{settings.iconStyle}}"></use>
                        </svg>
                        <span class="info">{{ translations.SignInToSeePrice }}</span>
                    </div>
                    {% if product.PreviousPrice != null and customer.HidePrices -%}
                        {% assign whatPrice = translations.Brutto | Downcase -%}
                        {% if customer.Cart.SubtotalPrices -%}
                            {% assign whatPrice = translations.Netto | Downcase -%}
                        {% endif -%}
                        <div class="quantity-container__suggested"><span class="value">{{ product.PreviousPrice }} {{ currencyExt }}</span> {{ whatPrice }} - {% if settings.previousPriceAsSuggestedRetailPrice == 'yes' -%} {{translations.SuggestedRetailPrice}} {% else -%} {{translations.PreviousPrice}} {% endif-%}</div>
                    {% endif -%}
                    <div class="quantity-container__lowest-price">
                        {% if settings.lowestProductPrice == 'yes' and product.MinPrice > 0 -%}
                            {{ product.MinPrice | ToPrice }} {{ currencyExt }} {{whatPrice}} - {{translations.Price_Omnibus}}
                        {% endif -%}
                    </div>
                {% elseif product.Price != null and customer.HidePrices == false -%}
                    {% if settings.thresholds == 'yes' and product.HasThresholds and product.Price != null -%}
                        {% assign whatPrice = translations.Brutto | Downcase -%}
                        {% if customer.Cart.SubtotalPrices -%}
                            {% assign whatPrice = translations.Netto | Downcase -%}
                        {% endif -%}
                        {% assign firstThreshold = product.Thresholds | First -%}
                        {% assign lastThreshold = product.Thresholds | Last -%}
                        <div class="quantity-container__label">{{ translations.Price }} {{ whatPrice }}</div>
                        <div class="quantity-container__range">
                            {{ translations.RangeFrom | Downcase }} <strong>{{ lastThreshold.FinalPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}</strong> {{ translations.RangeTo | Downcase }} {{ firstThreshold.FinalPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}
                        </div>
                        {% assign thresholdsSize = product.Thresholds | Size -%}
                        {% if thresholdsSize >= 2 -%}
                            <button class="quantity-container__open-thresholds-popup pure-button open-next-element-js stop-propagation-js">
                                <span>{{ translations.SeePriceDetails }}</span>
                            </button>
                            <div class="popup-background hidden-js hide-js container-to-hide-js">
                                <div class="popup thresholds-popup">
                                    <div class="popup__header">
                                        <div class="title">{{ translations.PriceDetails }}</div>
                                        <svg class="hide-container-js">
                                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
                                        </svg>
                                    </div>
                                    <div class="popup__content">
                                        <div class="name">{{ product.Name }}</div>
                                        <div class="thresholds">
                                            <div class="thresholds__row">
                                                <span>{{ translations.Quantity }} [{{ product.SaleUnit }}]:</span>
                                                <span>{{ translations.Price }} {{ whatPrice }}:</span>
                                            </div>
                                            {% for threshold in product.Thresholds -%}
                                                <div class="thresholds__row">
                                                    <div>{{ threshold.Threshold | Normalize }}+</div>
                                                    <div>{{ threshold.FinalPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}</div>
                                                </div>
                                            {% endfor %}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        {% endif -%}
                    {% else -%}
                        <div class="quantity-container__price-container">
                            <span class="price">{{ product.Price | ToPrice }} {{ currencyExt }}</span>
                            {% if product.PreviousPrice > product.Price and product.PreviousPrice != null -%}
                                {% if settings.previousPriceAsSuggestedRetailPrice != 'yes' -%}
                                    <span class="previous">
                                        {{ product.PreviousPrice | ToPrice }} {{ currencyExt }}
                                    </span>
                                {% endif -%}
                            {% elseif product.RegularPrice > product.Price and product.RegularPrice != null and config.ENTERPRISE and settings.lowestProductPrice == 'no' -%}
                                <span class="previous">{{ product.RegularPrice | ToPrice }} {{ currencyExt }}</span>
                            {% endif -%}
                            <span class="label">{{whatPrice}}</span>
                        </div>
                        {% if product.UnitPriceUnit != null -%}
                            <div class="quantity-container__unit-price">
                                {{ product.Price | Times: product.UnitPriceRatio | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} {{whatPrice}}/{{ product.UnitPriceUnit }}
                            </div>
                        {% endif -%}
                        {% if product.DepositValue > 0 -%}
                            <div class="quantity-container__deposit-price-container">
                                <span class="deposit">+ {{ translations.Com_Deposit }}: {{ product.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}</span>
                            </div>
                        {% endif -%}
                        {% if settings.lowestProductPrice == 'yes' and product.MinPrice > 0 -%}
                            <div class="quantity-container__lowest-price">{{ product.MinPrice | ToPrice }} {{ currencyExt }} {{whatPrice}} - {{translations.Price_Omnibus}}</div>
                        {% endif -%}
                        {% if settings.previousPriceAsSuggestedRetailPrice == 'yes' and product.PreviousPrice != null -%}
                            <div class="quantity-container__lowest-price">{{ product.PreviousPrice | ToPrice }} {{ currencyExt }} {{whatPrice}} - {{translations.SuggestedRetailPrice}}</div>
                        {% endif -%}
                    {% endif -%}
                {% endif -%}
                
                {% if showCouponsPopup -%}
                <div class="product-item__coupons-container">
                    <input type="hidden" name="productId" value="{{ product.Id }}" />
                    <input type="hidden" name="productCode" value="{{ product.Code | H }}" />
                    <input type="hidden" name="productName" value="{{ product.NameNoHtml | H }}" />
                    <input type="hidden" name="productImage" value="{{ productImageForCoupons }}" />
                    <button class="show-more-coupons-product-list show-more-coupons-product-list-js" style="position: relative;z-index: 2;" data-product-id="{{product.Id}}" data-url="{{ page.BaseHref }}{{config.DefinedPages.CustomerProfile.Url}}">{{ translations.ShowDiscounts }}</button>
                </div>
                {% endif -%}
                
                <div class="quantity-container__availability-container">
                    {% unless settings.showAvailabilityStatus == 'no' and product.Availability.Status == 1 -%}
                        <div class="availability">
                            {% if product.Availability.ImageUrl != '' and product.Availability.Type != 3 -%}
                                <img alt="{{ product.Availability.Text }}" src="css/img/alo.gif" data-src="{{ product.Availability.ImageUrl }}"> 
                                {% if product.Availability.Type == 2 -%}
                                    {{translations.Availability}}
                                {% endif -%}
                            {% endif -%}
                            {% if product.Availability.Type != 2 -%}
                                {% if product.Availability.Status == 0 or product.Availability.Status == 2 -%}
                                    {{product.Availability.Text}}
                                {% elseif product.Availability.Status == 1 -%}
                                    {{translations.Available}}
                                    {% if settings.showAvailabilityStatus == 'yes' and product.Availability.Text != '' -%}
                                        {{product.Availability.Text | Downcase}}
                                    {% endif -%}
                                {% elseif product.Availability.Status == 3 -%}
                                    {{translations.NotAvailable}}
                                {% endif -%}
                            {% endif -%}
                        </div>
                    {% endunless -%}
                    {% if product.Availability.Date and product.Availability.Status == 0 -%}
                        {% include 'partials/common/date-format.html' -%}
                        <div>{{translations.PreviewDate}}: {{product.Availability.Date | Date: dateFormat}}</div>
                    {% endif -%}
                </div>
                <div class="quantity-container__stock-container">
                    {% if usr.Authenticated == false and settings.notAuthStock == 'no' -%}
                        {% assign showStock = false -%}
                    {% else -%}
                        {% assign showStock = true -%}
                    {% endif -%}
                    {% if config.Stock.Enabled and page.PageId == config.DefinedPages.ProductList.Id and showStock -%}
                        {% if product.StockLevel.Control and product.HasAttributes == false -%}
                            {% assign isTitle = false -%}
                            {% if product.StockLevel.Type == 1 and product.StockLevel.Text != '' -%}
                                {% assign isTitle = true -%}
                            {% endif -%}
                            {% if product.StockLevel.ImageUrl != null -%}
                                {% if product.StockLevel.Type == 1 or product.StockLevel.Type == 2 -%}
                                    <img alt="{{ product.StockLevel.Text }}" src="css/img/alo.gif" data-src="{{product.StockLevel.ImageUrl}}" {% if isTitle -%} title="{{ product.StockLevel.Text }}" {% endif -%} >
                                {% endif -%}
                            {% endif -%}
                            <div class="stock">
                                {{translations.InStock}}{% if product.StockLevel.Type == 1 or product.StockLevel.Type == 3 -%}: {{ product.StockLevel.Text }}{% elseif product.StockLevel.Type == 4 -%}: {{ product.StockLevel.Value | Normalize }}{% endif %}
                            </div>
                        {% endif -%}
                    {% endif -%}
                </div>
                <div class="quantity-container__form form-js add-to-cart-js container-js">
                    {% if customer.HidePrices and usr.Authenticated == false -%}
                        {% if settings.signIn == "page" -%}
                            <a class="secondary-action-button sign-in" href="{{ page.BaseHref }}{{config.DefinedPages.Login.Url}}" rel="nofollow">
                                <span class="secondary-action-button__name">{{ translations.LogIn }}</span>
                                <svg class="secondary-action-button__icon">
                                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#user-{{settings.iconStyle}}"></use>
                                </svg>
                            </a>
                        {% else -%}
                            <a class="secondary-action-button sign-in show-login-popup-js" rel="nofollow">
                                <span class="secondary-action-button__name">{{ translations.LogIn }}</span>
                                <svg class="secondary-action-button__icon">
                                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#user-{{settings.iconStyle}}"></use>
                                </svg>
                            </a>
                        {% endif -%}
                    {% elseif product.Price == null or product.AskForPrice -%}
                        <a class="primary-action-button" href="{{ page.BaseHref }}{{ product.Url | H }}?open=askForPrice">
                            <span class="primary-action-button__name">{{ translations.AskForPrice }}</span>
                            <svg class="primary-action-button__icon">
                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#comment-alt-dollar-{{settings.iconStyle}}"></use>
                            </svg>
                        </a>
                    {% elseif notifyAvailability and isPhantom == false -%}
                        <a class="primary-action-button" href="{{ page.BaseHref }}{{ product.Url | H }}?open=notifyMe">{{ translations.NotifyAboutAvailability }}</a>
                    {% elseif productWithAttributes or isPhantom -%}
                        {% if page.PageId == config.DefinedPages.ProductList.Id and settings.allowAddingToCartMultiVariantProductsOnProductsList == "no" -%}
                            <a class="primary-action-button" href="{{ page.BaseHref }}{{product.Url}}">
                                <span class="primary-action-button__text">
                                    {{ translations.AvailableProductVariants }}
                                </span>
                                <svg class="primary-action-button__icon">
                                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#shapes-{{settings.iconStyle}}"></use>
                                </svg>
                            </a>
                        {% else -%}
                            <button class="primary-action-button {% if page.PageId == config.DefinedPages.ProductList.Id and settings.allowAddingToCartMultiVariantProductsOnProductsList == "yes" -%} choose-variant-js {% endif -%}" data-url="{{ page.BaseHref }}{{product.Url}}">
                                <span class="primary-action-button__text">
                                    {{ translations.AvailableProductVariants }}
                                </span>
                                <svg class="primary-action-button__icon">
                                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#shapes-{{settings.iconStyle}}"></use>
                                </svg>
                            </button>
                        {% endif -%}
                    {% else -%}
                        <input type="hidden" name="__action" value="Cart/Add">
                        <input type="hidden" name="productId" value="{{product.Id}}">
                        {% if settings.productIsInCart == 'productIsInCart-yes' -%}
                            <input type="hidden" class="isInCartId" value="{{product.Id}}">
                        {% endif -%}
                        {% include 'partials/product/amount-stepper.html' with product -%}
                        <span class="unit">
                            {% assign showBasicUnitInfo = false -%}
                            {% if settings.showUnitRateOnProductDetailsPageUnit == 'basic' and product.BasicUnit != unitName -%}
                                {% assign showBasicUnitInfo = true -%}
                            {% endif -%}
                            {% if product.Units[1] -%}
                                <div tabindex="0" class="unit__list select select-js">
                                    <select id="unit-select-{{ product.Id }}" class="memory-js" data-index="0" aria-label="{{ translations.Unit }}">
                                        {% for unit in product.Units -%}
                                            {% if unit.Id == unitId -%}
                                                {% assign defaultUnitName = unit.Name -%}
                                            {% endif -%}
                                            <option value="{{ unit.Id }}" {% if unit.Id == unitId -%} selected {% endif -%}>{{ unit.Name | H }}</option>
                                        {% endfor -%}
                                    </select>
                                    <div class="select__input">
                                        <span class="selected-js">
                                            {{ defaultUnitName | H }}
                                        </span>
                                        <svg>
                                            <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}'></use>
                                        </svg>
                                    </div>
                                    <ul class="select__options options-js replace-template-js">
                                        {% for unit in product.Units -%}
                                            <li class="parent-container-reload-js" data-ratio="{{ unit.Ratio }}" data-value="{{ unit.Id }}" data-url="{{ url }}?unit={{ unit.Id }}">{{ unit.Name | H }}</li>
                                        {% endfor -%}
                                    </ul>
                                </div>
                                {% if settings.showUnitRateOnProductDetailsPage == 'yes' %}
                                    {% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
                                        {% if defaultUnit == false and unitId != null -%}
                                            <div class="unit__ratio-info">
                                                {{ unitRatio | DividedBy: product.BasicUnitRatio | Round: 4 }} {{product.SaleUnit}}
                                            </div>
                                        {% endif -%}
                                    {% else -%}
                                        {% if product.BasicUnit != unitName -%}
                                            <div class="unit__ratio-info">
                                                {{ unitRatio | Round: 4 }} {{product.BasicUnit}}
                                            </div>
                                        {% endif -%}
                                    {% endif -%}
                                {% endif -%}
                            {% else -%}
                                {{ product.SaleUnit }}
                                {% if showBasicUnitInfo -%}
                                    <div class="unit__ratio-info">{{product.BasicUnitRatio | Round: 4}} {{product.BasicUnit}}</div>
                                {% endif -%}
                            {% endif -%}                        
                        </span>
                        {% if product.BasicUnitMinQuantity > 1 -%}
                            <div class="min-quantity-info">
                                <svg>
                                    <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#exclamation-triangle-{{settings.iconStyle}}'></use>
                                </svg>
                                <span>
                                    {{ translations.FillProperMinQuantity }} <strong>{{ product.BasicUnitMinQuantity | Round }} {{ product.SaleUnit }}</strong>
                                </span>
                            </div>
                        {% endif -%}
                        <div class="validation-container">
                            <div class="validation validation-info-js validation-required-js hidden-js">{{ translations.FillQuantity }}</div>
                            <div class="validation validation-info-js validation-quantity-range-js hidden-js">{{ translations.FillProperQuantityRange }} <span class="min-js">{{ min }}</span> - <span class="max-js">{{ max }}</span></div>
                            <div class="validation validation-info-js validation-quantity-range-max-js hidden-js">{{ translations.FillProperQuantityRangeMax }} <span class="max-js">{{ max }}</span></div>
                        </div>
                        <div class="primary-buttons">
                            <button class="primary-action-button add-to-cart-update-client-area-js parent-container-reload-js {% comment -%}{% if customer.Authenticated == false -%} with-wishlist {% endif -%}{% endcomment -%}">
                                <span class="primary-action-button__text">{{ translations.AddToCart }}</span>
                                <svg class="primary-action-button__icon">
                                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#shopping-cart-{{settings.iconStyle}}"></use>
                                </svg>
                                {% if settings.productIsInCart == 'productIsInCart-yes' -%}
                                    <svg class="svgIcon svgIcon-inCart isInCartIcon-js hidden-js">
                                        <use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-circle-{{settings.iconStyle}}"></use>
                                    </svg>
                                {% endif -%}
                            </button>
                            {% if settings.productIsInCart == 'productIsInCart-yes' -%}
                                <div class="isInCartPopup isInCartPopup-js" style="display: none">
                                    {{translations.productIsInCart}}
                                </div>
                            {% endif -%}
                            {% if customer.Authenticated == true -%}
                                <button aria-label="{{ translations.AddToWishList }}" class="secondary-action-button wishlist {% if config.B2B == false -%} add-to-wishlist-js {% else -%} show-add-to-wishlist-popup-js{% endif -%}">
                                    <svg class="secondary-action-button__icon">
                                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#clipboard-list-{{settings.iconStyle}}"></use>
                                    </svg>
                                </button>
                            {% endif -%}
                            {% if customer.Authenticated == true or settings.compareProducts == 'yes' or settings.inquiries == 'yes' and config.B2B -%}
                                <div class="more-options-mobile select-wcag-js">
                                    <button aria-label="{{ translations.ShowMore }}" class="secondary-action-button actions toggle-options-mobile-js">
                                        <svg class="secondary-action-button__icon">
                                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#ellipsis-v-{{settings.iconStyle}}"></use>
                                        </svg>
                                    </button>
                                    <ul class="more-options-mobile__items more-options-mobile-js dropdown-js hidden-js">
                                        {% if customer.Authenticated == true -%}
                                            <li role="button" tabindex="0" class="{% if config.B2B == false -%} add-to-wishlist-js {% else -%} show-add-to-wishlist-popup-js{% endif -%}">{{ translations.AddToWishList }}</li>
                                        {% endif -%}
                                        {% if settings.inquiries == 'yes' and config.B2B -%}
                                            <li role="button" tabindex="0" class="add-to-inquiry-js add-to-cart-update-client-area-js parent-container-reload-js">{{ translations.AddToQuote }}</li>
                                        {% endif -%}
                                        {% if settings.compareProducts == 'yes' -%}
                                            <li role="button" tabindex="0" class="mobile-comparison-btn-js {% if isInComparison == false -%}add-to-comparison-js{% else -%}remove-from-comparison-js{% endif -%}" data-product-id="{{product.Id}}">
                                                <span>
                                                    {% if isInComparison == false -%}
                                                        {{translations.Compare}}
                                                    {% else -%}
                                                        {{translations.DeleteFromCompare}}
                                                    {% endif -%}
                                                </span>
                                            </li>
                                        {% endif -%}
                                    </ul>
                                </div>
                            {% endif -%}
                        </div>
                        <div class="secondary-buttons">
                            {% if settings.inquiries == 'yes' and config.B2B -%}
                                <button class="secondary-action-button add-to-inquiry-js add-to-cart-update-client-area-js parent-container-reload-js" style="white-space: nowrap;">
                                    <span class="secondary-action-button__text">{{translations.ToInquiry}}</span>
                                    <svg class="secondary-action-button__icon">
                                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#file-invoice-dollar-{{settings.iconStyle}}"></use>
                                    </svg>
                                </button>
                            {% endif -%}

                            {% if settings.compareProducts == 'yes' -%}
								<button class="secondary-action-button {% if isInComparison == false -%}add-to-comparison-js{% else -%}remove-from-comparison-js{% endif -%}" data-product-id="{{product.Id}}">
									<span class="secondary-action-button__text">
										{% if isInComparison == false -%}
											{{translations.Compare}}
										{% else -%}
											{{translations.Delete}}
										{% endif -%}
									</span>
									<svg class="secondary-action-button__icon">
										<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#balance-scale-left-{{settings.iconStyle}}"></use>
									</svg>
								</button>
							{% endif -%}
                        </div>
                    {% endif -%}
                </div>
            </div>
        </div>
    </div>
{% elseif view == 'quick-shopping' -%}
    <div class="products-list__quick-shopping-view-product product-item-js">
        <a tabindex="-1" href="{{ page.BaseHref }}{{ product.Url }}" class="products-list__list-view-product--product-container-link" aria-label="{{translations.ShowDetails}}"></a>
        <div class="content-container">
            <div class="content-container__name">
                <a href="{{ page.BaseHref }}{{ product.Url }}">{{ product.NameNoHtml | H }}</a>
            </div>
            <div class="content-container__attributes">
                {{ product.Code | H }}
                {% assign attributesSize = product.AttributesList.Attributes | Size -%}
                {% assign attributeIndex = 1 -%}
                {% if settings.showAttributesOnProductsPage == 'yes' -%}
                    {% assign attributesLimiter = 0 -%}
                    {% for attribute in product.AttributesList.Attributes -%}
                        {% assign attributeName = attribute.Name | Downcase -%}
                        {% if attributeName contains '360photo' -%}
                            {% assign attributeIndex = attributeIndex | Plus:1 -%}
                        {% else -%}
                            {% assign valuesSize = attribute.Values | Size -%}
                            {% assign valueIndex = 1 -%}
                            <span class="separator">|</span> 
                            {% for value in attribute.Values -%}
                                {{ value.Value }}{% if valueIndex != valuesSize -%}, {% endif -%}
                                {% assign valueIndex = valueIndex | Plus:1 -%}
                            {% endfor %}
                            {% assign attributeIndex = attributeIndex | Plus:1 -%}
                            {% assign attributesLimiter = attributesLimiter | Plus: 1 -%}
                            {% unless settings.showAllAttributesOnQuickView -%}
                                {% if attributesLimiter == settings.attributesQuantityOnQuickView -%}
                                    {% break -%}
                                {% endif -%}
                            {% endunless -%}
                        {% endif -%}
                    {% endfor %}
                {% endif -%}
                {% if product.Manufacturer.Name -%}
                    <span class="separator">|</span> {{ product.Manufacturer.Name }}
                {% endif -%}
                {% if product.Brand.Name -%}
                    <span class="separator">|</span> {{ product.Brand.Name }}
                {% endif -%}
                {% if product.Weight > 0 -%}
                    <span class="separator">|</span> {{ product.Weight | Normalize }} {{ translations.Kg }}
                {% endif -%}
            </div>
        </div>
        <div class="prices-container">
            {% if product.PreviousPrice != null and customer.HidePrices -%}
                {% assign whatPrice = translations.Brutto | Downcase -%}
                {% if customer.Cart.SubtotalPrices -%}
                    {% assign whatPrice = translations.Netto | Downcase -%}
                {% endif -%}
                <div class="prices-container__suggested"><span class="value">{{ product.PreviousPrice }} {{ currencyExt }}</span> {{ whatPrice }} - {% if settings.previousPriceAsSuggestedRetailPrice == 'yes' -%} {{translations.SuggestedRetailPrice}} {% else -%} {{translations.PreviousPrice}} {% endif-%}</div>
            {% endif -%}
            {% if product.Price != null and customer.HidePrices == false -%}
                {% if settings.thresholds == 'yes' and product.HasThresholds and product.Price != null -%}
                    {% assign whatPrice = translations.Brutto | Downcase -%}
                    {% if customer.Cart.SubtotalPrices -%}
                        {% assign whatPrice = translations.Netto | Downcase -%}
                    {% endif -%}
                    {% assign firstThreshold = product.Thresholds | First -%}
                    {% assign lastThreshold = product.Thresholds | Last -%}
                    <div class="prices-container__label">{{ translations.Price }} {{ whatPrice }}</div>
                    <div class="prices-container__range">
                        {{ translations.RangeFrom | Downcase }} <strong>{{ lastThreshold.FinalPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}</strong> {{ translations.RangeTo | Downcase }} {{ firstThreshold.FinalPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}
                    </div>
                    {% assign thresholdsSize = product.Thresholds | Size -%}
                    {% if thresholdsSize >= 2 -%}
                        <button class="prices-container__open-thresholds-popup pure-button open-next-element-js stop-propagation-js">
                            <span>{{ translations.SeePriceDetails }}</span>
                        </button>
                        <div class="popup-background hidden-js hide-js container-to-hide-js">
                            <div class="popup thresholds-popup">
                                <div class="popup__header">
                                    <div class="title">{{ translations.PriceDetails }}</div>
                                    <svg class="hide-container-js">
                                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
                                    </svg>
                                </div>
                                <div class="popup__content">
                                    <div class="name">{{ product.Name }}</div>
                                    <div class="thresholds">
                                        <div class="thresholds__row">
                                            <span>{{ translations.Quantity }} [{{ product.SaleUnit }}]:</span>
                                            <span>{{ translations.Price }} {{ whatPrice }}:</span>
                                        </div>
                                        {% for threshold in product.Thresholds -%}
                                            <div class="thresholds__row">
                                                <div>{{ threshold.Threshold | Normalize }}+</div>
                                                <div>{{ threshold.FinalPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}</div>
                                            </div>
                                        {% endfor %}
                                    </div>
                                </div>
                            </div>
                        </div>
                    {% endif -%}
                {% else -%}
                    <div class="prices-container__price-container">
                        <span class="price">{{ product.Price | ToPrice }} {{ currencyExt }}</span>
                        {% if product.PreviousPrice > product.Price and product.PreviousPrice != null -%}
                            {% if settings.previousPriceAsSuggestedRetailPrice != 'yes' -%}
                                <span class="previous">
                                    {{ product.PreviousPrice | ToPrice }} {{ currencyExt }}
                                </span>
                            {% endif -%}
                        {% elseif product.RegularPrice > product.Price and product.RegularPrice != null and config.ENTERPRISE and settings.lowestProductPrice == 'no' -%}
                            <span class="previous">{{ product.RegularPrice | ToPrice }} {{ currencyExt }}</span>
                        {% endif -%}
                        <span class="label">{{whatPrice}}</span>
                    </div>
                    {% if product.DepositValue > 0 -%}
                        <div class="prices-container__deposit-price-container">
                            <span class="deposit">+ {{ translations.Com_Deposit }}: {{ product.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}</span>
                        </div>
                    {% endif -%}
                    {% if settings.lowestProductPrice == 'yes' and product.MinPrice > 0 -%}
                        <div class="prices-container__lowest-price">{{ product.MinPrice | ToPrice }} {{ currencyExt }} {{whatPrice}} - {{translations.Price_Omnibus}}</div>
                    {% endif -%}
                    {% if settings.previousPriceAsSuggestedRetailPrice == 'yes' and product.PreviousPrice != null -%}
                        <div class="prices-container__lowest-price">{{ product.PreviousPrice | ToPrice }} {{ currencyExt }} {{whatPrice}} - {{translations.SuggestedRetailPrice}}</div>
                    {% endif -%}
                {% endif -%}
            {% endif -%}
            
            {% if showCouponsPopup -%}
            <div class="product-item__coupons-container">
                <input type="hidden" name="productId" value="{{ product.Id }}" />
                <input type="hidden" name="productCode" value="{{ product.Code | H }}" />
                <input type="hidden" name="productName" value="{{ product.NameNoHtml | H }}" />
                <input type="hidden" name="productImage" value="{{ productImageForCoupons }}" />
                <button class="show-more-coupons-product-list show-more-coupons-product-list-js" style="position: relative;z-index: 2;" data-product-id="{{product.Id}}" data-url="{{ page.BaseHref }}{{config.DefinedPages.CustomerProfile.Url}}">{{ translations.ShowDiscounts }}</button>
            </div>
            {% endif -%}
        </div>
        <div class="quantity-container form-js add-to-cart-js container-js">
            <div class="quantity-container__availability-container">
                {% unless settings.showAvailabilityStatus == 'no' and product.Availability.Status == 1 -%}
                    <div class="availability">
                        {% if product.Availability.ImageUrl != '' and product.Availability.Type != 3 -%}
                            <img alt="{{ product.Availability.Text }}" src="css/img/alo.gif" data-src="{{ product.Availability.ImageUrl }}"> 
                            {% if product.Availability.Type == 2 -%}
                                {{translations.Availability}}
                            {% endif -%}
                        {% endif -%}
                        {% if product.Availability.Type != 2 -%}
                            {% if product.Availability.Status == 0 or product.Availability.Status == 2 -%}
                                {{product.Availability.Text}}
                            {% elseif product.Availability.Status == 1 -%}
                                {{translations.Available}}
                                {% if settings.showAvailabilityStatus == 'yes' and product.Availability.Text != '' -%}
                                    {{product.Availability.Text | Downcase}}
                                {% endif -%}
                            {% elseif product.Availability.Status == 3 -%}
                                {{translations.NotAvailable}}
                            {% endif -%}
                        {% endif -%}
                    </div>
                {% endunless -%}
                {% if product.Availability.Date and product.Availability.Status == 0 -%}
                    {% include 'partials/common/date-format.html' -%}
                    <div>{{translations.PreviewDate}}: {{product.Availability.Date | Date: dateFormat}}</div>
                {% endif -%}
            </div>
            <div class="quantity-container__stock-container">
                {% if usr.Authenticated == false and settings.notAuthStock == 'no' -%}
                    {% assign showStock = false -%}
                {% else -%}
                    {% assign showStock = true -%}
                {% endif -%}
                {% if config.Stock.Enabled and page.PageId == config.DefinedPages.ProductList.Id and showStock -%}
                    {% if product.StockLevel.Control and product.HasAttributes == false -%}
                        {% assign isTitle = false -%}
                        {% if product.StockLevel.Type == 1 and product.StockLevel.Text != '' -%}
                            {% assign isTitle = true -%}
                        {% endif -%}
                        {% if product.StockLevel.ImageUrl != null -%}
                            {% if product.StockLevel.Type == 1 or product.StockLevel.Type == 2 -%}
                                <img alt="{{ product.StockLevel.Text }}" src="css/img/alo.gif" data-src="{{product.StockLevel.ImageUrl}}" {% if isTitle -%} title="{{ product.StockLevel.Text }}" {% endif -%} >
                            {% endif -%}
                        {% endif -%}
                        <div class="stock">
                            {{translations.InStock}}{% if product.StockLevel.Type == 1 or product.StockLevel.Type == 3 -%}: {{ product.StockLevel.Text }}{% elseif product.StockLevel.Type == 4 -%}: {{ product.StockLevel.Value | Normalize }}{% endif %}
                        </div>
                    {% endif -%}
                {% endif -%}
            </div>
            {% if customer.HidePrices and usr.Authenticated == false -%}
            {% elseif product.Price == null or product.AskForPrice -%}
                <a class="primary-action-button" href="{{ page.BaseHref }}{{ product.Url | H }}?open=askForPrice">
                    <span class="primary-action-button__name">{{ translations.AskForPrice }}</span>
                    <svg class="primary-action-button__icon">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#comment-alt-dollar-{{settings.iconStyle}}"></use>
                    </svg>
                </a>
            {% elseif notifyAvailability and isPhantom == false -%}
                <a class="primary-action-button" href="{{ page.BaseHref }}{{ product.Url | H }}?open=notifyMe">{{ translations.NotifyAboutAvailability }}</a>
            {% elseif productWithAttributes or isPhantom -%}
                {% if page.PageId == config.DefinedPages.ProductList.Id and settings.allowAddingToCartMultiVariantProductsOnProductsList == "no" -%}
                    <a class="primary-action-button" href="{{ page.BaseHref }}{{product.Url}}">
                        <span class="primary-action-button__text">
                            {{ translations.AvailableProductVariants }}
                        </span>
                        <svg class="primary-action-button__icon">
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#shapes-{{settings.iconStyle}}"></use>
                        </svg>
                    </a>
                {% else -%}
                    <button class="primary-action-button {% if page.PageId == config.DefinedPages.ProductList.Id and settings.allowAddingToCartMultiVariantProductsOnProductsList == "yes" -%} choose-variant-js {% endif -%}" data-url="{{ page.BaseHref }}{{product.Url}}">
                        <span class="primary-action-button__text">
                            {{ translations.AvailableProductVariants }}
                        </span>
                        <svg class="primary-action-button__icon">
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#shapes-{{settings.iconStyle}}"></use>
                        </svg>
                    </button>
                {% endif -%}             
            {% else -%}
                <input type="hidden" name="__action" value="Cart/Add">
                <input type="hidden" name="productId" value="{{product.Id}}">
                {% if settings.productIsInCart == 'productIsInCart-yes' -%}
                    <input type="hidden" class="isInCartId" value="{{product.Id}}">
                {% endif -%}
                {% include 'partials/product/amount-stepper.html' with product -%}
                <span class="quantity-container__unit">
                    {{product.SaleUnit}}
                </span>
                <div class="quantity-container__validation-container">
                    <div class="validation validation-info-js validation-required-js hidden-js">{{ translations.FillQuantity }}</div>
                    <div class="validation validation-info-js validation-quantity-range-js hidden-js">{{ translations.FillProperQuantityRange }} <span class="min-js">{{ min }}</span> - <span class="max-js">{{ max }}</span></div>
                    <div class="validation validation-info-js validation-quantity-range-max-js hidden-js">{{ translations.FillProperQuantityRangeMax }} <span class="max-js">{{ max }}</span></div>
                </div>
                {% if product.BasicUnitMinQuantity > 1 -%}
                    <div class="min-quantity-info">
                        <svg>
                            <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#exclamation-triangle-{{settings.iconStyle}}'></use>
                        </svg>
                        <span>
                            {{ translations.FillProperMinQuantity }} <strong>{{ product.BasicUnitMinQuantity | Round }} {{ product.SaleUnit }}</strong>
                        </span>
                </div>
                {% endif -%}
            {% endif -%}
        </div>
    </div>
{% else -%}
    <div class="products-list__grid-view-product product-phantom-js product-item-js">
        <a tabindex="-1" href="{{ page.BaseHref }}{{ product.Url }}" class="products-list__list-view-product--product-container-link" aria-label="{{translations.ShowDetails}}"></a>
        <div class="image-container">
            {% if product.ImageId == -1 -%}
                <svg class="no-image">
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#image-{{settings.iconStyle}}"></use>
                </svg>
            {% else -%}
                {{ product | Img:'large' }}
            {% endif -%}
            <div class='image-container__flags'>
                {% if product.Archival -%}
                    <div class="ribbon archival">{{ translations.ArchivalProduct}}</div>
                {% endif -%}
                {% for flag in product.Flags limit:2 -%}
                    <div class="ribbon {{flag.Type}}">
                        {% if flag.Type == "Reward" -%}
                            {{ translations.PointsProduct }}
                        {% else -%}
                            {{ flag.Text }}
                        {% endif -%}
                    </div>
                {% endfor %}
            </div>
			{% if settings.showRotateImageOnList == 'showRotateImageOnList-yes' -%}
                {% assign is360photo = false -%}
				{% for attribute in product.AttributesList.Attributes -%}
					{% assign attributeName = attribute.Name | Downcase -%}
					{% if attributeName contains '360photo' -%}
						{% if attribute.Values[0].Value != '' -%}
                            {% assign is360photo = true -%}
							<input type="hidden" class="photoLink" value="{{attribute.Values[0].Value}}">
						{% endif -%}
					{% endif -%}
				{% endfor -%}

                {% if is360photo == true -%}
                    <div class="open360 open360-js open-popup-with-form" data-popup-class=".image-rotate-popup" data-product-list="true">
                        <svg>
                            <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#360'></use>
                        </svg>
                    </div>
                {% endif -%}
			{% endif -%}
            <div class="product-item__phantom product-item__new {% if isGraphicalPresentation == false -%} hidden {% endif -%}" data-url="{{ page.BaseHref }}{{ product.Url }}" data-base="{{ page.BaseHref }}" data-id="{{ product.Id }}" data-attributes="{{ product.HasAttributes }}" data-poly="{{ product.AttributesPolyvalent.length }}" data-clip="{{product.AttributesList.Clip}}" data-settings="{{ settings.grapicalVariantsPresentation }}">
                {% if settings.grapicalVariantsPresentation == 'Variants_DropDownList' -%}
                    <div class="form__input-info input-info-js on-label" data-attribute-name style="top: 9px;"></div>
                    <div class="select__input product-item__phantom--select select-js">
                        <span class="selected-js product-item__phantom--select-active"></span>
                        <svg>
                            <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}'></use>
                        </svg>
                        <ul class="product-item__phantom-first product-item__phantom-row options-js" data-id="{{ product.Id }}" ></ul>
                    </div>
                {% else -%}
                <div class="product-item__phantom-first product-item__phantom-row" data-id="{{ product.Id }}" data-attributes="{{ product.HasAttributes }}" ></div>
                {% endif -%}
            </div>
        </div>
        <div class="content-container">
            <div class="content-container__code">{{ translations.ProductCode }}: {{ product.Code | H }}</div>
            <div class="content-container__name">
                <a href="{{ page.BaseHref }}{{ product.Url }}">{{ product.NameNoHtml | H }}</a>
            </div>
            {% if customer.HidePrices and usr.Authenticated == false -%}
                <div class="content-container__login-to-see-prices">
                    <svg class="icon">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#lock-alt-{{settings.iconStyle}}"></use>
                    </svg>
                    <span class="info">{{ translations.SignInToSeePrice }}</span>
                </div>
                <div class="content-container__suggested">
                    {% if product.PreviousPrice != null and customer.HidePrices -%}
                        {% assign whatPrice = translations.Brutto | Downcase -%}
                        {% if customer.Cart.SubtotalPrices -%}
                            {% assign whatPrice = translations.Netto | Downcase -%}
                        {% endif -%}
                        <span class="value">{{ product.PreviousPrice }} {{ currencyExt }}</span> {{ whatPrice }} - {% if settings.previousPriceAsSuggestedRetailPrice == 'yes' -%} {{translations.SuggestedRetailPrice}} {% else -%} {{translations.PreviousPrice}} {% endif-%}
                    {% endif -%}
                </div>
                <div class="content-container__lowest-price">
                    {% if settings.lowestProductPrice == 'yes' and product.MinPrice > 0 -%}
                        {{ product.MinPrice | ToPrice }} {{ currencyExt }} {{whatPrice}} - {{translations.Price_Omnibus}}
                    {% endif -%}
                </div>
                {% elseif product.Price != null and customer.HidePrices == false -%}
                {% if settings.thresholds == 'yes' and product.HasThresholds and product.Price != null -%}
                    {% assign whatPrice = translations.Brutto | Downcase -%}
                    {% if customer.Cart.SubtotalPrices -%}
                        {% assign whatPrice = translations.Netto | Downcase -%}
                    {% endif -%}
                    {% assign firstThreshold = product.Thresholds | First -%}
                    {% assign lastThreshold = product.Thresholds | Last -%}
                    <div class="content-container__label">{{ translations.Price }} {{ whatPrice }}</div>
                    <div class="content-container__range">
                        {{ translations.RangeFrom | Downcase }} <strong>{{ lastThreshold.FinalPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}</strong> {{ translations.RangeTo | Downcase }} {{ firstThreshold.FinalPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}
                    </div>
                    {% assign thresholdsSize = product.Thresholds | Size -%}
                    {% if thresholdsSize >= 2 -%}
                        <button class="content-container__open-thresholds-popup pure-button open-next-element-js stop-propagation-js">
                            <span>{{ translations.SeePriceDetails }}</span>
                        </button>
                        <div class="popup-background hidden-js hide-js container-to-hide-js">
                            <div class="popup thresholds-popup">
                                <div class="popup__header">
                                    <div class="title">{{ translations.PriceDetails }}</div>
                                    <svg class="hide-container-js">
                                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
                                    </svg>
                                </div>
                                <div class="popup__content">
                                    <div class="name">{{ product.Name }}</div>
                                    <div class="thresholds">
                                        <div class="thresholds__row">
                                            <span>{{ translations.Quantity }} [{{ product.SaleUnit }}]:</span>
                                            <span>{{ translations.Price }} {{ whatPrice }}:</span>
                                        </div>
                                        {% for threshold in product.Thresholds -%}
                                            <div class="thresholds__row">
                                                <div>{{ threshold.Threshold | Normalize }}+</div>
                                                <div>{{ threshold.FinalPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}</div>
                                            </div>
                                        {% endfor %}
                                    </div>
                                </div>
                            </div>
                        </div>
                    {% endif -%}
                {% else -%}
                    <div class="content-container__price-container">
                        <span class="price">{{ product.Price | ToPrice }} {{ currencyExt }}</span>
                        {% if product.PreviousPrice > product.Price and product.PreviousPrice != null -%}
                            {% if settings.previousPriceAsSuggestedRetailPrice != 'yes' -%}
                                <span class="previous">
                                    {{ product.PreviousPrice | ToPrice }} {{ currencyExt }}
                                </span>
                            {% endif -%}
                        {% elseif product.RegularPrice > product.Price and product.RegularPrice != null and config.ENTERPRISE and settings.lowestProductPrice == 'no' -%}
                            <span class="previous">{{ product.RegularPrice | ToPrice }} {{ currencyExt }}</span>
                        {% endif -%}
                        <span class="label">{{whatPrice}}</span>
                    </div>
                    <div class="content-container__unit-price">
                        {% if product.UnitPriceUnit != null -%}
                            {{ product.Price | Times: product.UnitPriceRatio | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} {{whatPrice}}/{{ product.UnitPriceUnit }}
                        {% endif -%}
                    </div>
                    {% if product.DepositValue > 0 -%}
                        <div class="content-container__deposit-price-container">
                            <span class="deposit">+ {{ translations.Com_Deposit }}: {{ product.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}</span>
                        </div>
                    {% endif -%}
                    <div class="content-container__lowest-price">
                        {% if settings.lowestProductPrice == 'yes' and product.MinPrice > 0 -%}
                            {{ product.MinPrice | ToPrice }} {{ currencyExt }} {{whatPrice}} - {{translations.Price_Omnibus}}
                        {% endif -%}
                    </div>
                    {% if settings.previousPriceAsSuggestedRetailPrice == 'yes' and product.PreviousPrice != null -%}
                        <div class="content-container__lowest-price">{{ product.PreviousPrice | ToPrice }} {{ currencyExt }} {{whatPrice}} - {{translations.SuggestedRetailPrice}}</div>
                    {% else -%}
                        <div class="content-container__lowest-price"></div>
                    {% endif -%}
                {% endif -%}
                {% else -%}
                <div class="content-container__price-container"></div>
                <div class="content-container__lowest-price"></div>
                <div class="content-container__lowest-price"></div>
            {% endif -%}
        </div>

        {% if showCouponsPopup -%}
        <div class="product-item__coupons-container">
            <input type="hidden" name="productId" value="{{ product.Id }}" />
            <input type="hidden" name="productCode" value="{{ product.Code | H }}" />
            <input type="hidden" name="productName" value="{{ product.NameNoHtml | H }}" />
            <input type="hidden" name="productImage" value="{{ productImageForCoupons }}" />
            <button class="show-more-coupons-product-list show-more-coupons-product-list-js" style="position: relative;z-index: 2;" data-product-id="{{product.Id}}" data-url="{{ page.BaseHref }}{{config.DefinedPages.CustomerProfile.Url}}">{{ translations.ShowDiscounts }}</button>
        </div>
        {% endif -%}

        <div class="buttons form-js add-to-cart-js container-js">
            {% if customer.HidePrices and usr.Authenticated == false -%}
                {% if settings.signIn == "page" -%}
                    <a class="secondary-action-button sign-in" href="{{ page.BaseHref }}{{config.DefinedPages.Login.Url}}" rel="nofollow">
                        <span class="secondary-action-button__name">{{ translations.LogIn }}</span>
                        <svg class="secondary-action-button__icon">
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#user-{{settings.iconStyle}}"></use>
                        </svg>
                    </a>
                {% else -%}
                    <a class="secondary-action-button sign-in show-login-popup-js" rel="nofollow">
                        <span class="secondary-action-button__name">{{ translations.LogIn }}</span>
                        <svg class="secondary-action-button__icon">
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#user-{{settings.iconStyle}}"></use>
                        </svg>
                    </a>
                {% endif -%}
            {% elseif product.Price == null or product.AskForPrice -%}
                <a class="primary-action-button" href="{{ page.BaseHref }}{{ product.Url | H }}?open=askForPrice">
                    <span class="primary-action-button__name">{{ translations.AskForPrice }}</span>
                    <svg class="primary-action-button__icon">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#comment-alt-dollar-{{settings.iconStyle}}"></use>
                    </svg>
                </a>
            {% elseif notifyAvailability and isPhantom == false -%}
                <a class="primary-action-button" href="{{ page.BaseHref }}{{ product.Url | H }}?open=notifyMe">{{ translations.NotifyAboutAvailability }}</a>
            {% elseif productWithAttributes or isPhantom -%}
                {% if page.PageId == config.DefinedPages.ProductList.Id and settings.allowAddingToCartMultiVariantProductsOnProductsList == "no" -%}
                    <a class="primary-action-button" href="{{ page.BaseHref }}{{product.Url}}">
                        <span class="primary-action-button__text">
                            {{ translations.AvailableProductVariants }}
                        </span>
                        <svg class="primary-action-button__icon">
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#shapes-{{settings.iconStyle}}"></use>
                        </svg>
                    </a>
                {% else -%}
                    <button class="primary-action-button {% if page.PageId == config.DefinedPages.ProductList.Id and settings.allowAddingToCartMultiVariantProductsOnProductsList == "yes" -%} choose-variant-js {% endif -%}" data-url="{{ page.BaseHref }}{{product.Url}}">
                        <span class="primary-action-button__text">
                            {{ translations.AvailableProductVariants }}
                        </span>
                        <svg class="primary-action-button__icon">
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#shapes-{{settings.iconStyle}}"></use>
                        </svg>
                    </button>
                {% endif -%}
            {% else -%}
                <input type="hidden" name="__action" value="Cart/Add">
                <input type="hidden" name="productId" value="{{product.Id}}">
                <input type="hidden" name="quantity" value="1">
                {% if settings.productIsInCart == 'productIsInCart-yes' -%}
                    <input type="hidden" class="isInCartId" value="{{product.Id}}">
                {% endif -%}
                <div class="primary-buttons">
                    <button class="primary-action-button add-to-cart-update-client-area-js parent-container-reload-js {% comment -%}{% if customer.Authenticated == false -%} with-wishlist {% endif -%}{% endcomment -%}">
                        <span class="primary-action-button__text">{{ translations.AddToCart }}</span>
                        <svg class="primary-action-button__icon">
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#shopping-cart-{{settings.iconStyle}}"></use>
                        </svg>
                        {% if settings.productIsInCart == 'productIsInCart-yes' -%}
                            <svg class="svgIcon svgIcon-inCart isInCartIcon-js hidden-js">
                                <use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-circle-{{settings.iconStyle}}"></use>
                            </svg>
                        {% endif -%}
                    </button>
                    {% if settings.productIsInCart == 'productIsInCart-yes' -%}
                        <div class="isInCartPopup isInCartPopup-js" style="display: none">
                            {{translations.productIsInCart}}
                        </div>
                    {% endif -%}
                    {% if customer.Authenticated == true -%}
                        <button aria-label="{{ translations.AddToWishList }}" class="secondary-action-button wishlist {% if config.B2B == false -%} add-to-wishlist-js {% else -%} show-add-to-wishlist-popup-js{% endif -%}">
                            <svg class="secondary-action-button__icon">
                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#clipboard-list-{{settings.iconStyle}}"></use>
                            </svg>
                        </button>
                    {% endif -%}
                </div>
            {% endif -%}
        </div>
    </div>
{% endif -%}
`